export const styles = {
  modalBox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 'auto',
    width: { xs: 380, md: 430 },
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    borderRadius: 5,
    p: 4,
  },
  fileInputBox: {
    pb: 4,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  fileLabel: {
    backgroundColor: "#f0f0f0",
    padding: "4px 14px",
    borderRadius: "20px",
    fontWeight: 500,
    cursor: "pointer",
    color: "#000",
    border: "1px solid #ccc",
    fontSize: "14px",
  },
  fileNameTypo: {
    color: "#555",
    fontSize: 14,
  },
  errorTypo: {
    pb: 2,
  },
  checkBox: {
    borderRadius: "50%",
    position: "absolute",
    bottom: "10px",
    right: "10px",
    padding: "3px",
    cursor: "pointer !important",
  },
  editIconBox: {
    position: "absolute",
    bottom: 0,
    right: 0,
    color: "blue",
    bgcolor: "white",
    borderRadius: "50%",
    border: "1px solid grey",
    cursor: "pointer",
    p: 0.5,
  },
  canvasStyle: {
    border: "1px solid black",
    objectFit: "cover",
    width: "100%",
    height: 200,
  },
  imgStyle: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
};
